(() => {
  // App prices (including Kaching bundles) can render after the theme's prices.
  const normalizeMoney = (element) => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const formatted = node.data.replace(/(\d)[., \u00a0\u202f](?=\d{3}(?:\D|$))/g, '$1');
      if (node.data !== formatted) node.data = formatted;
    }
  };

  const collectMoney = (node, elements) => {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return;
    const money = element.closest('.money');
    if (money) elements.add(money);
    element.querySelectorAll('.money').forEach((item) => elements.add(item));
  };

  document.querySelectorAll('.money').forEach(normalizeMoney);

  const observer = new MutationObserver((mutations) => {
    const elements = new Set();
    mutations.forEach((mutation) => {
      collectMoney(mutation.target, elements);
      mutation.addedNodes.forEach((node) => collectMoney(node, elements));
    });
    elements.forEach(normalizeMoney);
  });
  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
})();
